import XIcon from "@mui/icons-material/Close"
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  IconButton,
  Stack,
  Typography,
} from "@mui/material"
import { DialogProps } from "./types"
import UserProfileUpload from "@/components/users/UserProfileUpload"
import { useState } from "react"
import { FileWithPath } from "react-dropzone"
import { PutObjectCommand } from "@aws-sdk/client-s3"
import { s3, warmS3Credentials } from "@/common/globals"
import useUpdateProfilePicture from "@/hooks/api/users/useUpdateProfilePicture"

type UserProfile = [
  {
    user_number: number
    email: string
    display_name: string
    role: number
    profile_picture_link: string
  }
]

interface ProfilePictureDialogProps extends DialogProps {
  userPicture?: string
  userProfile: UserProfile
}

export default function ProfilePictureDialog({
  isOpen,
  closeDialog,
  userPicture,
  userProfile,
}: ProfilePictureDialogProps) {
  function handleClose() {
    closeDialog()
  }

  const [profileImage, setProfileImage] = useState<FileWithPath>()
  const { mutateAsync: updateUser } = useUpdateProfilePicture(
    userProfile[0].user_number
  )

  const onSubmit = async () => {
    // Ensure S3 credentials are ready before uploading
    await warmS3Credentials()

    const params = {
      Bucket: `${import.meta.env.VITE_AWS_PROFILE_BUCKET}`,
      Key: `${String(userProfile[0].user_number)}/${profileImage?.name}`,
      Body: profileImage,
      ContentType: profileImage?.type,
    }

    try {
      await s3.send(new PutObjectCommand(params))

      updateUser({
        imageUrl: `https://${
          import.meta.env.VITE_AWS_PROFILE_BUCKET
        }.s3.us-east-2.amazonaws.com/${userProfile[0].user_number}/${
          profileImage?.name
        }`,
      })
    } catch (err) {
      console.error("There was a problem uploading images", err)
    }
  }
  return (
    <Dialog open={isOpen} onClose={handleClose}>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        minWidth={"500px"}
        pl={3}
        pr={1}
        py={1}
        sx={{
          backgroundColor: "white",
          color: "black",
        }}
      >
        <Typography>Upload Profile Image</Typography>
        <Box>
          <IconButton color="inherit" onClick={handleClose}>
            <XIcon />
          </IconButton>
        </Box>
      </Stack>
      <DialogContent
        sx={{
          py: 2,
        }}
      >
        <UserProfileUpload
          profileImage={profileImage}
          setProfileImage={setProfileImage}
          userPicture={userPicture}
        />
        <Stack
          direction="row"
          justifyContent="space-between"
          spacing={2}
          mt={5}
        >
          <Button variant="text" color="inherit" onClick={handleClose}>
            Cancel
          </Button>

          <Button
            variant="contained"
            color="primary"
            type="submit"
            onClick={onSubmit}
          >
            Save
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  )
}
